import React, { useEffect } from 'react';
import { useLegalDocumentT } from '../hooks/useLegalDocumentT.ts';
import { PrivacyDocumentContent } from '../components/legal/LegalDocumentContents.tsx';
import './css/PrivacyPolicyPage.css';

const LAST_UPDATED = '18.04.2026';

export default function PrivacyPolicyPage() {
  const { t, legalLang } = useLegalDocumentT();

  useEffect(() => {
    const previous = document.documentElement.lang;
    document.documentElement.lang = legalLang;
    return () => {
      document.documentElement.lang = previous;
    };
  }, [legalLang]);

  return (
    <div className="legal-page privacy-policy-page">
      <div className="legal-page-container">
        <h1 className="legal-page-title">{t('privacyPolicy.title')}</h1>
        <p className="legal-page-updated">{t('privacyPolicy.lastUpdated')}: {LAST_UPDATED}</p>
        <PrivacyDocumentContent t={t} />
      </div>
    </div>
  );
}
